import axios from "axios";
import settings from "@/settings";
import router from "@/router";


let newPaymentsHistorySearchData = {
    company_name: null,
    start_date: null,
    end_date: null,
    bank_name: null,
    description: null,
    reference_number: null,
    status: null,
};

export default {
    namespaced: true,
    state: {
        paymentsHistory: [],
        loadingPaymentData: null,
        activePayment: {},
        paymentsHistorySearch: {...newPaymentsHistorySearchData},
        loadingPaymentsHistoryList: false,
        paymentHistoryTableOptions: null,
        paymentHistoryTotalPaymentsCount: 0,
    },
    mutations: {
        setPayments(state, val) {
            state.paymentsHistory = val;
        },

        setPaymentHistoryStatus(state, val) {
            state.activeStatus = val;
        },
        setPaymentHistoryDataLoading(state, bool) {
            state.loadingPaymentData = bool;
        },
        setActivePayment(state, value) {
            state.activePayment = value;
        },
        setPaymentsHistoryListLoading(state, bool) {
            state.loadingPaymentsHistoryList = bool;
        },
        updatePaymentsHistorySearch(state, {prop, value}) {
            if (value === "") value = null;
            state.paymentsHistorySearch = {
                ...state.paymentsHistorySearch,
                [prop]: value
            };
        },
        updatePaymentsHistoryDateSearch(state, payload) {
            state.paymentsHistorySearch = {...state.paymentsHistorySearch, ...payload};
        },
        resetPaymentsHistorySearch(state) {
            state.paymentsHistorySearch = {...newPaymentsHistorySearchData};
        },
        setPaymentHistoryTableOptions(state, options) {
            state.paymentHistoryTableOptions = options;
        },
        setPaymentsTotalCount(state, value) {
            state.paymentHistoryTotalPaymentsCount = value;
        },
    },
    actions: {
        async getPaymentsHistory({commit, state}) {
            commit("setPaymentsHistoryListLoading", true);
            commit("setRequestSuccess", false, {root: true});
            commit("setRequestError", false, {root: true});
            try {
                let options = state.paymentHistoryTableOptions;
                let search = state.paymentsHistorySearch;
                let params = {
                    company_name: search && search.company_name ? search.company_name : null,
                    start_date: search && search.start_date ? search.start_date : null,
                    end_date: search && search.end_date ? search.end_date : null,
                    status: search && search.status ? search.status : null,
                    swift: search && search.swift ? search.swift : null,
                    bank_name: search && search.bank_name ? search.bank_name : null,
                    reference_number: search && search.reference_number ? search.reference_number : null,
                    description: search && search.description ? search.description : null,
                    page: options && options.page ? options.page : null,
                    itemsPerPage: options && options.itemsPerPage ? options.itemsPerPage : null,
                    sortBy: options && options.sortBy[0] ? options.sortBy[0] : null,
                    sortDesc: options && options.sortDesc ? options.sortDesc[0] : null
                };
                const response = await axios.get(settings.app_url + "/payments-history/", {params});
                const data = response.data;
                if (data.success === 1) {
                    commit("setPayments", data.payments);
                    commit("setBanks", data.bank_array, {root: true});
                    commit("setPaymentsTotalCount", data.total_payments_count);
                    commit("setPaymentHistoryStatus", data.status);
                } else {
                    commit("setPayments", []);
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                commit("setRequestError", true, {root: true});
                commit("setErrorMessage", "Failed", {root: true});
            }
            commit("setPaymentsHistoryListLoading", false);
        },
        async getPaymentData({commit}, paymentId) {
            commit("setPaymentHistoryDataLoading", true);
            commit("setRequestSuccess", false, {root: true});
            commit("setRequestError", false, {root: true});
            try {
                let response = await axios.get(settings.app_url + "/payment-history/" + paymentId);
                if (response && response.data && response.status === 200 && response.data.success === 1) {
                    let data = response.data;
                    commit("setActivePayment", data.payment_data);
                } else {
                    commit("setActivePayment", {});
                    //commit("toggleDrawer", false);
                    router.push("/admin/payments-history");
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true, {root: true});
                commit("setErrorMessage", "Failed", {root: true});
            }
            commit("setPaymentHistoryDataLoading", false);
        },
    }
}